import { LocationStrategy } from "@angular/common";
import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { AppService } from "@api";
import { SistemaService } from "@servicios/Sistema.Service";
import { AlineacionImagenEnum } from "@componentes/Enums.enum";
import { EvaluacionComponent } from "@contenido/AppContent/global/evaluacion/evaluacion.component";
import { HeaderEnum, RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum, DialogoEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { AlumnoEvaluacion } from "@modelo/global/AlumnoEvaluacion.model";
import { EvaluacionPendienteVisualizacion } from "@modelo/proceso/evaluacionpendientevisualizacion.model";


@Component(
    {
        selector: 'alumno',
        templateUrl: './alumno.component.html',
        styleUrls: ['./alumno.component.scss']
    })

    export class AlumnoComponent implements AfterViewInit{
        consulta!: boolean;
        @Input() metodoevaluacion!: number;
        @Input() entidad!: AlumnoEvaluacion;
        @Input() valores!: any;
        @Output() output = new EventEmitter();
        titulo:string = "";
        cantidaddeevaluaciones:any[];
        cantidadevaluacion: number = 0;
        listapreguntas:any;
        objobservacion: any;
        visualizacion: EvaluacionPendienteVisualizacion;

        public AlineacionImagenEnum = AlineacionImagenEnum;

        @ViewChild('datosDesdeElPadre') private evaluacion!: EvaluacionComponent;

        constructor(private appService: AppService,private location: LocationStrategy, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver){
            this.entidad = new AlumnoEvaluacion();
            this.listapreguntas = [];
            this.visualizacion = new EvaluacionPendienteVisualizacion();
            this.cantidaddeevaluaciones = [];
        }

        ngAfterViewInit(){
            this.SetPreguntas();
        }

        SetPreguntas(){
            this.appService.Post("evaluacionpendiente/alumno/alumnobuscarpreguntas",{"entidad":this.entidad, "valores": this.valores}).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success){
                    this.objobservacion = res.data.observacion[0];
                    this.visualizacion = new EvaluacionPendienteVisualizacion(res.data.visualizacion);
                    if(this.visualizacion.tipovisualizacionrespuestaid == 2){
                        this.listapreguntas = res.data.pregunta;
                         if(this.listapreguntas.length == 0){
                            this.listapreguntas = [];
                            this.mensajeService.Alerta(AlertaEnum.Warning, "Esta evaluación no tinene preguntas, por favor comunícate con un administrador");
                            this.output.next();
                        }else{
                            this.listapreguntas.map((pregunta:any)=>{
                                pregunta.colortext = this.cambiarcolor(pregunta.color);
                            })
                        }
                    }else{
                        this.cantidaddeevaluaciones = res.data.pregunta;
                        this.listapreguntas = this.cantidaddeevaluaciones[this.cantidadevaluacion];
                        if(!this.listapreguntas){
                            this.listapreguntas = [];
                            this.mensajeService.Alerta(AlertaEnum.Warning, "Este Alumno no tiene ninguna evaluación, por favor comunícate con un administrador");
                            this.output.next();
                        }
                    }

                }
            })
        }

        cambiarcolor(color :any): string {
            let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
            let val:any = [];
            if(result){
                let r = parseInt(result[1], 16)
                let g = parseInt(result[2], 16)
                let b = parseInt(result[3], 16)
                val = this.rgbToHsl(r,g,b);
            }
            if(val[2] < 50){
                return "colorblanco"
            }else{

                return "colornegro";
            }
        }

        rgbToHsl(r:any, g:any, b:any){
            r /= 255;
            g /= 255;
            b /= 255;

            // Find greatest and smallest channel values
            let cmin = Math.min(r,g,b),
            cmax = Math.max(r,g,b),
            delta = cmax - cmin,
            h = 0,
            s = 0,
            l = 0;

            // Calculate hue
            // No difference
            if (delta == 0)
            h = 0;
            // Red is max
            else if (cmax == r)
            h = ((g - b) / delta) % 6;
            // Green is max
            else if (cmax == g)
            h = (b - r) / delta + 2;
            // Blue is max
            else
            h = (r - g) / delta + 4;

            h = Math.round(h * 60);

            // Make negative hues positive behind 360°
            if (h < 0)
            h += 360;

            // Calculate lightness
            l = (cmax + cmin) / 2;

            // Calculate saturation
            s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

            // Multiply l and s by 100
            s = +(s * 100).toFixed(1);
            l = +(l * 100).toFixed(1);

            return [h, s, l];
        }

        empezarencuesta(){
            let cantidad  = this.cantidaddeevaluaciones.length
            let val = this.cantidadevaluacion + 1
            if(val < cantidad){
                this.cantidadevaluacion = this.cantidadevaluacion + 1;
                this.listapreguntas = this.cantidaddeevaluaciones[this.cantidadevaluacion];
                this.evaluacion.listapreguntas = this.listapreguntas
                this.evaluacion.conteocompetencia = 0
                this.evaluacion.conteocriterio = 0
                this.evaluacion.conteopregunta = 0
                this.evaluacion.cargarinfo();

            }else{
            let opciones = this.sistemaService.GetOpcionesSalirEvaluacion();
            this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'A completado todas las evaluaciones.<br> de click en salir para cerrar la evaluación', opciones).then(res => {
                if (res == 1) {
                    this.consulta = true;
                    this.output.next(this.consulta);
                }
            });
            }
        }

        sinterminar(){
            if(this.entidad.bloquearevaluacion){
                let opciones = this.sistemaService.GetOpcionesSalir();
                this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Advertencia <br> Se quedaron preguntas sin contestar. <br> ¿Estás seguro de querer salir de la evaluación?', opciones).then(res => {
                    if (res == 1) {
                        this.consulta = true;
                        this.output.next(this.consulta);
                    }
                });
            }else if(!this.entidad.bloquearevaluacion){
                let opciones = this.sistemaService.GetOpcionesSalir();
                this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Advertencia <br> Se quedaron preguntas sin contestar. <br> Al dar salir se finalizará la evaluación y no podrás volver a entrar. <br> ¿Estás seguro de querer salir de la evaluación?', opciones).then(res => {
                    if (res == 1) {
                        this.appService.Post("evaluacionpendiente/colaborador", {"entidad": this.entidad, "evaluaciopendienteestatus": 1}).then(res => {
                            if(res.status == RespuestaEstatusEnum.Success) {
                                this.consulta = true;
                                this.output.next(this.consulta);
                            }
                        })
                    }
                });
            }
        }
        terminado(){
            this.appService.Post("evaluacionpendiente/colaborador", {"entidad": this.entidad, "evaluaciopendienteestatus": 1}).then(res => {
                if(res.status == RespuestaEstatusEnum.Success) {
                    this.consulta = true;
                    this.output.next(this.consulta);
                }
            })
        }
        salir(){
            this.output.next();
        }

        guardarrespuesta(entidad:any){
            this.appService.Post("evaluacionpendiente/alumno/guardarrespuestaalumno",{"evaluacionpendienterespuestaid": entidad.evaluacionpendienterespuestaid,"tipopreguntaid":entidad.tipopreguntaid ,"escalaevaluacionvalorid": entidad.escalaevaluacionvalorid}).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success){
                }
            })
        }

        guardarcomentario(respuesta:any){
            if(this.objobservacion.length > 0){
                this.appService.Post("evaluacionpendiente/colaborador/guardarrespuesta",{"evaluacionpendienterespuestaid": this.objobservacion.evaluacionpendienterespuestaid, "observacion": respuesta}, [HeaderEnum.NoShowLoading]).then(res=>{
                    if(res.status == RespuestaEstatusEnum.Success){
                    }
                })
            }else{
                this.appService.Post("evaluacionpendiente/colaborador/guardarrespuesta",{"entidad": this.entidad, "observacion": respuesta}, [HeaderEnum.NoShowLoading]).then(res=>{
                    if(res.status == RespuestaEstatusEnum.Success){
                        if(res.data.observacion){
                            this.objobservacion = res.data.observacion[0];
                        }
                    }
                })
            }
        }
    }